
// API Configuration
// export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8081";
export const API_URL = process.env.REACT_APP_API_URL || "https://webapi.datarate.io";

// Google Analytics Configuration
export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID || "";

// Popup timer
export const popupTimer = 3000;


export const validateWebsite = (item) => {
  if (
    /(https?:\/\/)?(www\.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)|(https?:\/\/)?(www\.)?(?!ww)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/.test(
      item
    )
  ) {
    return item.includes('https://') ||item.includes('http://');

  } else if (
    /^((https?:\/\/)|(www.))(?:([a-zA-Z]+)|(\d+\.\d+.\d+.\d+)):\d{0,5}$/.test(
      item
    )
  ) {
    return item.includes('https://') ||item.includes('http://');
  } else {
    return false;
  }
};

// Input validation limits - prevents DoS and injection attacks
export const INPUT_LIMITS = {
  // Text fields
  NAME: 100,                    // Names, titles
  DESCRIPTION: 2000,            // Descriptions, bios
  COMMENT: 5000,                // Comments, feedback
  URL: 2048,                    // URLs (RFC 7230 max)
  TAG: 50,                      // Individual tags
  EMAIL: 254,                   // Email addresses (RFC 5321 max)
  SEARCH: 200,                  // Search queries
  
  // Special cases
  TICKET_DESCRIPTION: 10000,    // Support tickets (longer allowed)
  AI_CHAT_MESSAGE: 10000,       // AI chat messages
  SPACE_DESCRIPTION: 5000,      // Space/collection descriptions
};
